import React from 'react'
import PageLayout from '../../templates/page-layout/page-layout'
import NavMenu from '../../atoms/nav-menu/nav-menu'
import { HAVE_TOP } from '../../../constants/activity-constants'
import './home-content.scss'
import TopSection from '../top-section/top-section'
import PremiosSection from '../premios-section/premios-section'
import TermsSection from '../terms-section/terms-section'
import AboutSection from '../about-section/about-section'
const links = {
  inicio: 'Inicio',
  mision: 'Tu misión',
}
if (HAVE_TOP) {
  links['top'] = 'Top jugadoras'
}
export default function HomeContent() {
  return (
    <PageLayout>
      <NavMenu links={links} />
      <PremiosSection id="inicio" />
      <AboutSection id="mision" />
      <TopSection id="top" />
      <TermsSection />
    </PageLayout>
  )
}
